import { computed } from 'vue';
import { useStore } from 'vuex';
import yup from '@component_path/inquiry_form_common_module/customValidation';

export const useFirstNameKanaField = (required, messages = {}) => {
  const validator = yup
    .string()
    .max(30, messages['max'] || 'めい（ふりがな）は30文字以内にしてください')
    .kanaFormat(
      messages['field'] || 'めい（ふりがな）',
      messages['kanaFormat'] ||
        'めい（ふりがな）はひらがな・カタカナのみ使用できます'
    )
    .requirement(
      required,
      messages['requirement'] || 'めい（ふりがな）は必須項目です'
    );
  const fieldName = computed(() => 'first_name_kana');

  return { validator, fieldName };
};

export const useFirstNameKanaStore = () => {
  const store = useStore();
  const firstNameKana = computed(() => store.state.formData.first_name_kana);
  const dispatcher = computed(() => 'formData/setFirstNameKana');

  return { firstNameKana, dispatcher };
};
